<script>
import { mapActions, mapGetters } from 'vuex';

import request from '@/services/request';
import Catalogue from '@/services/catalogue';
import Pagination from 'vue-pagination-2';
import ModalFormComponentContracts from '@/components/contracts_new/ModaFormComponent.vue';
import ModalRulesBillingComponent from '@/components/rules_billing/ModalRulesBillingComponent.vue';

export default {
    name: 'rules-billing-table',

    components: {
        Pagination,
        ModalFormComponentContracts,
        ModalRulesBillingComponent
    },

    data() {
        return {
            editForm: false,
            load: false,
            catalogue: new Catalogue(),
            page: 1,
            years: Array.from({ length: 20 }, (v, i) => 2020 + i),
            search: {
                search: '',
                building_id: '',
                company_id: '',
                status: 1,
                finish: '',
                user_id: '',
                month: '',
                year: '',
                payment_period_id: [1, 2, 3, 4, 6, 7, 8, 9]
            }
        };
    },

    methods: {
        rules(contract) {
            Event.$emit('event-show-addCreateBillExternalRuless', contract);
        },

        showAddendum(idContract) {
            this.editForm = false;
            Event.$emit('event-show-showContractID', idContract);
        },

        addendum(buy) {
            this.editForm = true;
            let addendum = 1;
            Event.$emit('event-show-renewContracts', buy, addendum);
        },

        showNewContracts(contract = false, edit = true) {
            this.editForm = edit;
            Event.$emit('event-show-addNewContracts', contract);
        },

        async list(page = 1) {
            this.load = true;
            let service = request;
            let search = this.search;
            search.search = this.name;
            let _endpoint = '/rules_billing';

            try {
                let { data } = await service.list(_endpoint, page, search);

                if (data) {
                    console.log(data);
                    this.buys = data;
                    this.load = false;
                }
            } catch (error) {
                console.log(error);
                this.load = false;
            }
        },

        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success'
        })
    },

    mounted() {
        this.list();
        this.catalogue.get_buildings();
        this.catalogue.get_companies_all();
        this.catalogue.get_users_profile(7);
        // this.catalogue.get_count_contracts_departments();
    },

    created() {
        Event.$on('event-load-contracts', () => {
            this.list();
        });
    },

    watch: {
        search: {
            handler: function () {
                this.list();
            },
            deep: true
        }
    },

    computed: {
        ...mapGetters({
            authUser: 'auth/user'
        })
    }
};
</script>

<template>
    <div class="col-12 pb-5">
        <ModalFormComponentContracts :prop_edit="editForm" />
        <ModalRulesBillingComponent />

        <div class="card contracts-module">
            <div class="card-header contracts-module__header">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div class="module-title mb-2 mb-lg-0">
                        <div class="d-flex align-items-center">
                            <i class="fa-solid fa-file-invoice-dollar mr-2"></i>
                            <h3 class="mb-0">Reglas de Facturación</h3>
                        </div>
                        <p class="mb-0">
                            Consulta los contratos y administra sus reglas de facturación.
                        </p>
                    </div>
                </div>
            </div>

            <div class="card-body contracts-module__body">
                <section class="filters-box">
                    <div class="filters-box__title">
                        <i class="fa-solid fa-filter mr-2"></i>
                        <strong>Filtros</strong>
                    </div>

                    <div class="row">
                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label>Propiedad</label>
                            <select v-model="search.building_id" class="form-control form-control-sm" @change="list()">
                                <option value="">Todas las propiedades</option>
                                <option v-for="(building, index) in catalogue.buildings" :key="index"
                                    :value="building.id">
                                    {{ building.name }}
                                </option>
                            </select>
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label>Empresa</label>
                            <select v-model="search.company_id" class="form-control form-control-sm" @change="list()">
                                <option value="">Todas las empresas</option>
                                <option v-for="(company, index) in catalogue.companies_all" :key="index"
                                    :value="company.id">
                                    {{ company.name }}
                                </option>
                            </select>
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label>Estatus</label>
                            <select v-model="search.finish" class="form-control form-control-sm" @change="list()">
                                <option value="">Todas las situaciones</option>
                                <!-- <option value="1">Por terminar</option> -->
                                <!-- <option value="2">Por incrementar</option> -->
                                <option value="3">Falta porcentaje</option>
                                <option value="4">Vencido sin finalizar</option>
                                <option value="5">Falta firma</option>
                            </select>
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3">
                            <label>Cliente</label>
                            <select v-model="search.user_id" class="form-control form-control-sm" @change="list()">
                                <option value="">Todos los clientes</option>
                                <option v-for="(user, user_index) in catalogue.users_profile" :key="user_index"
                                    :value="user.id">
                                    {{ user.name }} {{ user.last_name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div v-if="search.finish" class="row">
                        <div class="col-sm-6 col-xl-3 mb-3 mb-xl-0">
                            <label>Fecha</label>
                            <select v-model="search.month" class="form-control form-control-sm" @change="list()">
                                <option value="">Todos los meses</option>
                                <option value="1">Enero</option>
                                <option value="2">Febrero</option>
                                <option value="3">Marzo</option>
                                <option value="4">Abril</option>
                                <option value="5">Mayo</option>
                                <option value="6">Junio</option>
                                <option value="7">Julio</option>
                                <option value="8">Agosto</option>
                                <option value="9">Septiembre</option>
                                <option value="10">Octubre</option>
                                <option value="11">Noviembre</option>
                                <option value="12">Diciembre</option>
                            </select>
                        </div>

                        <div class="col-sm-6 col-xl-3">
                            <label>Año</label>
                            <select v-model="search.year" class="form-control form-control-sm" @change="list()">
                                <option value="">Todos los años</option>
                                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                            </select>
                        </div>
                    </div>
                </section>

                <div class="contract-status-navigation">
                    <ul id="custom-tabs-one-tab" class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: search.status == 1 }" data-toggle="pill" role="tab"
                                :aria-selected="search.status == 1 ? 'true' : 'false'" @click="search.status = 1">
                                <i class="fa-solid fa-circle-check mr-1"></i>
                                Activos
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: search.status == 2 }" data-toggle="pill" role="tab"
                                :aria-selected="search.status == 2 ? 'true' : 'false'" @click="search.status = 2">
                                <i class="fa-solid fa-box-archive mr-1"></i>
                                Terminados
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="table-responsive contracts-table-wrapper">
                    <table class="table contracts-table mb-0">
                        <thead>
                            <tr>
                                <th class="id-column">ID</th>
                                <th class="contract-info-column">DATOS DEL PAGO</th>
                                <th>FECHA</th>
                                <th>RENTA / DEPÓSITO</th>
                                <th>SERVICIOS</th>
                                <th>OPCIONES</th>
                            </tr>
                        </thead>

                        <tbody v-if="load">
                            <tr>
                                <td colspan="7">
                                    <div class="table-state">
                                        <i class="fa-solid fa-circle-notch fa-spin fa-2x"></i>
                                        <span>Cargando contratos...</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>

                        <tbody v-else-if="buys.data && buys.data.length > 0">
                            <tr v-for="(buy, index) in buys.data" :key="index" class="contract-row"
                                :class="{ 'contract-row--authorized': buy.authorization_user_id }">
                                <td class="id-column">
                                    <strong class="contract-id">
                                        #{{ buy.id }}
                                    </strong>

                                    <div class="billing-rule-indicator" :class="buy.rules_billing && buy.rules_billing.length > 0
                                        ? 'billing-rule-indicator--applied'
                                        : 'billing-rule-indicator--pending'" :title="buy.rules_billing && buy.rules_billing.length > 0
                ? 'Este contrato tiene reglas de facturación configuradas'
                : 'Este contrato todavía no tiene reglas de facturación'">
                                        <span class="billing-rule-indicator__icon">
                                            <i :class="buy.rules_billing && buy.rules_billing.length > 0
                                                ? 'fa-solid fa-circle-check'
                                                : 'fa-solid fa-circle-exclamation'"></i>
                                        </span>

                                        <span class="billing-rule-indicator__content">
                                            <strong>
                                                {{ buy.rules_billing && buy.rules_billing.length > 0
                                                    ? 'Regla aplicada'
                                                : 'Sin regla'
                                                }}
                                            </strong>

                                            <small v-if="buy.rules_billing && buy.rules_billing.length > 0">
                                                {{ buy.rules_billing.length === 1 ? 'configuración' : 'configuraciones'
                                                }}
                                            </small>

                                            <small v-else>
                                                Pendiente
                                            </small>
                                        </span>
                                    </div>
                                </td>

                                <td class="contract-info-column text-left">
                                    <div class="contract-main-info">
                                        <div class="building-name">
                                            <i class="fa-regular fa-building mr-1"></i>
                                            {{ buy.building ? buy.building.name : 'SIN PROPIEDAD' }}
                                        </div>

                                        <span class="contract-detail-text">
                                            <strong>Cliente:</strong>
                                            <template v-if="buy.user">
                                                {{ buy.user.name }} {{ buy.user.last_name }}
                                            </template>
                                            <template v-else>Sin usuario</template>
                                        </span>

                                        <span class="contract-detail-text">
                                            <strong>Recurrencia:</strong>
                                            {{ buy.payment_period ? buy.payment_period.name : 'Sin recurrencia' }}
                                        </span>

                                        <span class="contract-detail-text">
                                            <strong>Fecha de registro:</strong>
                                            {{ buy.created_at | toDateTime }}
                                        </span>

                                        <span class="contract-detail-text">
                                            <strong>Renta única:</strong>
                                            <span class="status-pill" :class="buy.unique_rent == 1
                                                ? 'contract-status--active'
                                                : 'contract-status--pending'">
                                                {{ buy.unique_rent == 1 ? 'Sí' : 'No' }}
                                            </span>
                                        </span>


                                    </div>

                                    <div v-if="buy.all_parent_ids.length >= 1" class="addendum-box">
                                        <div class="addendum-box__header">
                                            <span class="addendum-box__icon">
                                                <i class="fa-solid fa-code-branch"></i>
                                            </span>
                                            <div>
                                                <strong>Addendum</strong>
                                                <small>Contratos relacionados</small>
                                            </div>
                                        </div>

                                        <div class="addendum-box__contracts">
                                            <button v-for="(parent, parentIndex) in buy.all_parent_ids"
                                                :key="parentIndex" type="button" class="parent-contract-button"
                                                :title="'Ver contrato #' + parent" @click="showAddendum(parent)">
                                                <i class="fa-regular fa-file-lines mr-1"></i>
                                                #{{ parent }}
                                            </button>
                                        </div>
                                    </div>

                                    <div v-if="buy.user_admin.length > 0 || buy.user_juridical.length > 0 || buy.user_auxiliary.length > 0"
                                        class="authorization-inline-list">
                                        <div v-if="buy.user_admin.length > 0"
                                            class="authorization-inline-item authorization-inline-item--complete">
                                            <span class="authorization-inline-item__icon">
                                                <i class="fa-solid fa-user-tie"></i>
                                            </span>
                                            <div>
                                                <strong>Administrador</strong>
                                                <span v-for="(admin, adminIndex) in buy.user_admin" :key="adminIndex">
                                                    {{ admin.user.name }} {{ admin.user.last_name }}
                                                </span>
                                            </div>
                                            <i class="fa-solid fa-circle-check authorization-inline-item__state"></i>
                                        </div>

                                        <div v-if="buy.user_juridical.length > 0"
                                            class="authorization-inline-item authorization-inline-item--complete">
                                            <span class="authorization-inline-item__icon">
                                                <i class="fa-solid fa-scale-balanced"></i>
                                            </span>
                                            <div>
                                                <strong>Jurídico</strong>
                                                <span v-for="(auxiliar, juridicalIndex) in buy.user_juridical"
                                                    :key="juridicalIndex">
                                                    {{ auxiliar.user.name }} {{ auxiliar.user.last_name }}
                                                </span>
                                            </div>
                                            <i class="fa-solid fa-circle-check authorization-inline-item__state"></i>
                                        </div>

                                        <div v-if="buy.user_auxiliary.length > 0"
                                            class="authorization-inline-item authorization-inline-item--complete">
                                            <span class="authorization-inline-item__icon">
                                                <i class="fa-solid fa-calculator"></i>
                                            </span>
                                            <div>
                                                <strong>Analista Contable</strong>
                                                <span v-for="(juridical, auxiliaryIndex) in buy.user_auxiliary"
                                                    :key="auxiliaryIndex">
                                                    {{ juridical.user.name }} {{ juridical.user.last_name }}
                                                </span>
                                            </div>
                                            <i class="fa-solid fa-circle-check authorization-inline-item__state"></i>
                                        </div>
                                    </div>

                                    <div class="department-list">
                                        <span v-for="(department, departmentIndex) in buy.departments"
                                            :key="departmentIndex" class="department-badge">
                                            Piso {{ department.level }} / {{ department.number }}
                                            <template v-if="department.date">
                                                - {{ department.date | toDateTime }}
                                            </template>
                                        </span>
                                    </div>
                                </td>

                                <td class="date-column">
                                    <strong v-if="buy.start_date">{{ buy.start_date | toDateTime }}</strong>
                                    <span v-else>Sin inicio</span>
                                    <span class="date-separator">al</span>
                                    <strong v-if="buy.end_date">{{ buy.end_date | toDateTime }}</strong>
                                    <span v-else>Sin fecha fin</span>
                                </td>

                                <td class="money-column">
                                    <template v-if="buy.unique_rent == 1 && buy.unique_rent_data">
                                        <strong class="money-current">
                                            {{ buy.unique_rent_data.subtotal | toCurrency }}
                                        </strong>
                                        <span class="contract-detail-text">Renta</span>
                                    </template>

                                    <template v-else-if="buy.departments">
                                        <div v-for="(department, rentIndex) in buy.departments" :key="rentIndex"
                                            class="money-line">
                                            <span>Renta / Piso {{ department.level }} / {{ department.number }}</span>
                                            <strong>{{ department.subtotal_rent | toCurrency }}</strong>
                                        </div>
                                    </template>

                                    <div v-if="buy.unique_deposit == 1" class="deposit-line">
                                        <span>Depósito</span>
                                        <strong>{{ buy.deposit_amount | toCurrency }}</strong>
                                    </div>

                                    <template v-else-if="buy.departments">
                                        <div v-for="(department, depositIndex) in buy.departments" :key="depositIndex"
                                            class="deposit-line">
                                            <span>Depósito / Piso {{ department.level }} / {{ department.number
                                                }}</span>
                                            <strong>{{ department.deposit | toCurrency }}</strong>
                                        </div>
                                    </template>
                                </td>

                                <td class="money-column services-column">
                                    <div v-if="buy.unique_services == 1">
                                        <div v-for="(service, serviceIndex) in buy.unique_services_data"
                                            v-show="service.include_rent == false && service.subtotal > 0"
                                            :key="serviceIndex" class="money-line">
                                            <span v-if="service.service">{{ service.service.name }}</span>
                                            <span v-else>{{ service.service_name }}</span>
                                            <strong>{{ service.subtotal | toCurrency }}</strong>
                                        </div>
                                    </div>

                                    <div v-else-if="buy.departments">
                                        <template v-for="(department, departmentServiceIndex) in buy.departments">
                                            <div v-for="(service, indexService) in department.services"
                                                v-show="service.include_rent == false && service.subtotal > 0"
                                                :key="departmentServiceIndex + '-' + indexService" class="money-line">
                                                <span>
                                                    {{ service.name }}
                                                    <small>Piso {{ department.level }} / {{ department.number }}</small>
                                                </span>
                                                <strong>{{ service.subtotal | toCurrency }}</strong>
                                            </div>
                                        </template>
                                    </div>
                                </td>

                                <td class="options-column">
                                    <div class="option-buttons">
                                        <button type="button" class="btn btn-outline-primary btn-sm"
                                            @click="showNewContracts(buy, false)">
                                            <i class="fa-solid fa-eye mr-1"></i>
                                            Ver
                                        </button>

                                        <button v-can="'edit_contracts'" type="button"
                                            class="btn btn-outline-secondary btn-sm" @click="rules(buy)">
                                            <i class="fa-solid fa-file-invoice-dollar mr-1"></i>
                                            Reglas de Facturación
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>

                        <tbody v-else>
                            <tr>
                                <td colspan="7">
                                    <div class="table-state">
                                        <i class="fa-regular fa-folder-open fa-2x"></i>
                                        <span>No se encontraron contratos.</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="!load && buys.total > 0" class="pagination-row">
                    <small>Mostrando {{ buys.data.length }} de {{ buys.total }} contratos</small>

                    <pagination v-model="page" :records="buys.total" :per-page="buys.per_page" @paginate="list" />
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.contracts-module {
    overflow: hidden;
    border: 1px solid #dfe3e7;
    border-top: 2px solid #6c757d;
    border-radius: 0.75rem;
    background: #ffffff;
    box-shadow: 0 0.25rem 0.75rem rgba(33, 37, 41, 0.08);
}

.contracts-module__header {
    padding: 1.5rem 1.75rem 1rem;
    border-bottom: 1px solid #e9ecef;
    background: #ffffff;
}

.module-title h3 {
    color: #2f3337;
    font-size: 1rem;
    font-weight: 700;
}

.module-title>div>i {
    color: #343a40;
}

.module-title p {
    margin-top: 0.35rem;
    padding-left: 1.7rem;
    color: #7b838b;
    font-size: 0.75rem;
}

.contracts-module__body {
    padding: 1.1rem 1.75rem 1.5rem;
}

.filters-box {
    padding: 1rem;
    border: 1px solid #dfe3e7;
    border-radius: 0.45rem;
    background: #f8f9fa;
}

.filters-box__title {
    display: flex;
    align-items: center;
    margin-bottom: 0.9rem;
    color: #2f3337;
    font-size: 0.9rem;
}

.filters-box label {
    display: block;
    margin-bottom: 0.35rem;
    color: #495057;
    font-size: 0.72rem;
    font-weight: 700;
}

.filters-box .form-control {
    height: 2.25rem;
    border-color: #ced4da;
    border-radius: 0.3rem;
    color: #495057;
    background: #ffffff;
    font-size: 0.78rem;
    box-shadow: none;
}

.filters-box .form-control:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.15rem rgba(0, 123, 255, 0.12);
}

.contract-status-navigation {
    margin: 1rem 0;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #e9ecef;
}

.contract-status-navigation .nav-pills {
    gap: 0.4rem;
}

.contract-status-navigation .nav-link {
    padding: 0.35rem 0.8rem;
    border: 1px solid #dee2e6;
    border-radius: 50rem;
    color: #6c757d;
    background: #ffffff;
    font-size: 0.72rem;
    font-weight: 600;
    cursor: pointer;
}

.contract-status-navigation .nav-link.active {
    border-color: #6c757d;
    color: #ffffff;
    background: #6c757d;
}

.contracts-table-wrapper {
    overflow: auto;
    max-height: 70vh;
    min-height: 500px;
    border: 1px solid #d9dee3;
    border-radius: 0.35rem;
}

.contracts-table {
    min-width: 1180px;
    color: #343a40;
    font-size: 0.72rem;
}

.contracts-table thead th {
    position: sticky;
    z-index: 2;
    top: 0;
    padding: 0.75rem 0.6rem;
    border-top: 0;
    border-right: 1px solid #d9dee3;
    border-bottom: 1px solid #cfd4d9;
    color: #495057;
    background: #f1f3f5;
    font-size: 0.65rem;
    font-weight: 700;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
}

.contracts-table tbody td {
    padding: 0.65rem 0.6rem;
    border-top: 0;
    border-right: 1px solid #e1e5e8;
    border-bottom: 1px solid #e1e5e8;
    background: #ffffff;
    text-align: center;
    vertical-align: middle;
}

.contract-row td:first-child {
    border-left: 3px solid transparent;
}

.contract-row--authorized td:first-child {
    border-left-color: #17a2b8;
}

.contract-row--authorized td {
    background: #f8fbfc;
}

.id-column {
    width: 4rem;
}

.contract-info-column {
    min-width: 19rem;
}

.contract-main-info {
    margin-bottom: 0.55rem;
}

.building-name {
    color: #343a40;
    font-weight: 700;
    text-transform: uppercase;
}

.contract-detail-text {
    display: block;
    margin-top: 0.15rem;
    color: #6c757d;
    font-size: 0.65rem;
}

.contract-detail-text strong {
    color: #495057;
}

.contract-detail-text .status-pill {
    min-width: 2.2rem;
    margin-left: 0.2rem;
    padding: 0.1rem 0.35rem;
    font-size: 0.58rem;
}

.department-list {
    margin-top: 0.5rem;
}

.department-badge {
    display: inline-block;
    margin: 0.1rem;
    padding: 0.18rem 0.4rem;
    border-radius: 50rem;
    color: #495057;
    background: #e9ecef;
    font-size: 0.62rem;
}

.date-column strong,
.date-column span {
    display: block;
}

.date-column strong {
    font-size: 0.68rem;
}

.date-separator {
    margin: 0.15rem 0;
    color: #adb5bd;
    font-size: 0.6rem;
}

.status-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 6.5rem;
    padding: 0.22rem 0.55rem;
    border-radius: 50rem;
    font-size: 0.65rem;
    font-weight: 700;
}

.contract-status--active {
    color: #155724;
    background: #d4edda;
}

.contract-status--pending {
    color: #856404;
    background: #fff3cd;
}

.authorization-inline-list {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    width: 100%;
    margin-top: 0.55rem;
    text-align: left;
}

.authorization-inline-item {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 2.25rem;
    padding: 0.3rem 1.55rem 0.3rem 0.4rem;
    border: 1px solid #dee2e6;
    border-radius: 0.3rem;
    background: #ffffff;
}

.authorization-inline-item--complete {
    border-color: #c3e6cb;
    background: #f4fbf6;
}

.authorization-inline-item__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 1.45rem;
    width: 1.45rem;
    height: 1.45rem;
    margin-right: 0.4rem;
    border-radius: 50%;
    color: #495057;
    background: #e9ecef;
    font-size: 0.55rem;
}

.authorization-inline-item>div {
    min-width: 0;
}

.authorization-inline-item>div strong,
.authorization-inline-item>div span {
    display: block;
}

.authorization-inline-item>div strong {
    color: #495057;
    font-size: 0.57rem;
    line-height: 1.15;
}

.authorization-inline-item>div span {
    overflow: hidden;
    margin-top: 0.08rem;
    color: #6c757d;
    font-size: 0.58rem;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.authorization-inline-item__state {
    position: absolute;
    top: 50%;
    right: 0.5rem;
    color: #28a745;
    font-size: 0.62rem;
    transform: translateY(-50%);
}

.money-column {
    min-width: 10rem;
}

.money-current {
    display: block;
    color: #212529;
    font-size: 0.82rem;
}

.money-line {
    padding: 0.25rem 0;
    border-bottom: 1px solid #f0f1f2;
}

.money-line:last-child {
    border-bottom: 0;
}

.money-line>span,
.money-line>strong {
    display: block;
}

.money-line>span {
    color: #6c757d;
    font-size: 0.62rem;
}

.money-line>span small {
    display: block;
    color: #adb5bd;
}

.money-line>strong {
    margin-top: 0.05rem;
    color: #212529;
    font-size: 0.75rem;
}

.deposit-line {
    margin-top: 0.35rem;
    padding-top: 0.35rem;
    border-top: 1px solid #dee2e6;
}

.deposit-line span,
.deposit-line strong {
    display: block;
}

.deposit-line span {
    color: #6c757d;
    font-size: 0.6rem;
}

.deposit-line strong {
    color: #138496;
    font-size: 0.75rem;
}

.options-column {
    min-width: 12rem;
}

.option-buttons {
    white-space: normal;
}

.option-buttons .btn {
    margin: 0.15rem;
    padding: 0.22rem 0.5rem;
    border-radius: 50rem;
    font-size: 0.68rem;
    font-weight: 600;
}

.table-state {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    min-height: 12rem;
    color: #6c757d;
}

.table-state i {
    margin-bottom: 0.6rem;
}

.pagination-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1rem;
    color: #6c757d;
}

.pagination-row ::v-deep .VuePagination__pagination {
    margin-bottom: 0;
}

.addendum-box {
    margin-top: 0.55rem;
    padding: 0.55rem;
    border: 1px solid #d9e2ec;
    border-left: 3px solid #17a2b8;
    border-radius: 0.35rem;
    background: #f8fbfc;
    text-align: left;
}

.addendum-box__header {
    display: flex;
    align-items: center;
}

.addendum-box__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 1.7rem;
    width: 1.7rem;
    height: 1.7rem;
    margin-right: 0.45rem;
    border-radius: 50%;
    color: #138496;
    background: #e3f4f7;
    font-size: 0.62rem;
}

.addendum-box__header strong,
.addendum-box__header small {
    display: block;
}

.addendum-box__header strong {
    color: #343a40;
    font-size: 0.63rem;
    font-weight: 700;
}

.addendum-box__header small {
    margin-top: 0.05rem;
    color: #868e96;
    font-size: 0.55rem;
}

.addendum-box__contracts {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    margin-top: 0.45rem;
    padding-left: 2.15rem;
}

.parent-contract-button {
    padding: 0.18rem 0.42rem;
    border: 1px solid #bee5eb;
    border-radius: 0.25rem;
    color: #117a8b;
    background: #ffffff;
    font-size: 0.58rem;
    font-weight: 600;
    cursor: pointer;
    transition: border-color 0.15s ease, background-color 0.15s ease;
}

.parent-contract-button:hover {
    border-color: #17a2b8;
    color: #0c6574;
    background: #eaf8fa;
}

.parent-contract-button:focus {
    outline: none;
    box-shadow: 0 0 0 0.15rem rgba(23, 162, 184, 0.15);
}

@media (max-width: 767.98px) {

    .contracts-module__header,
    .contracts-module__body {
        padding-right: 1rem;
        padding-left: 1rem;
    }

    .pagination-row {
        align-items: flex-start;
        flex-direction: column;
    }
}


.contract-id {
    display: block;
    margin-bottom: 0.4rem;
    color: #343a40;
    font-size: 0.78rem;
    text-align: center;
}

.billing-rule-indicator {
    display: inline-flex;
    align-items: center;
    width: 100%;
    min-width: 7.2rem;
    padding: 0.35rem 0.45rem;
    border: 1px solid transparent;
    border-radius: 0.35rem;
    text-align: left;
}

.billing-rule-indicator__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 1.45rem;
    width: 1.45rem;
    height: 1.45rem;
    margin-right: 0.4rem;
    border-radius: 50%;
    font-size: 0.58rem;
}

.billing-rule-indicator__content {
    min-width: 0;
}

.billing-rule-indicator__content strong,
.billing-rule-indicator__content small {
    display: block;
}

.billing-rule-indicator__content strong {
    font-size: 0.59rem;
    font-weight: 700;
    line-height: 1.15;
    white-space: nowrap;
}

.billing-rule-indicator__content small {
    margin-top: 0.08rem;
    font-size: 0.52rem;
    line-height: 1.15;
    white-space: nowrap;
}

/* Regla configurada */
.billing-rule-indicator--applied {
    border-color: #c3e6cb;
    background: #f4fbf6;
}

.billing-rule-indicator--applied .billing-rule-indicator__icon {
    color: #155724;
    background: #d4edda;
}

.billing-rule-indicator--applied strong {
    color: #155724;
}

.billing-rule-indicator--applied small {
    color: #4f7659;
}

/* Regla pendiente */
.billing-rule-indicator--pending {
    border-color: #ffeeba;
    background: #fffaf0;
}

.billing-rule-indicator--pending .billing-rule-indicator__icon {
    color: #856404;
    background: #fff3cd;
}

.billing-rule-indicator--pending strong {
    color: #856404;
}

.billing-rule-indicator--pending small {
    color: #8a7440;
}
</style>
